<div class="flex h-48 w-full items-center">
    <button
        class="flex size-full items-center rounded hovered-layer pressed-layer px-8 text-left"
        type="button"
        (click)="itemClick.emit(item())"
    >
        <span class="line-clamp-1 min-w-0 typo-sm">
            {{ displayTitle() }}
        </span>
    </button>

    <interacta-menu-actions-button
        [args]="item()"
        [ariaLabel]="
            'SHARED.ACCESSIBILITY.OPEN_ITEM_MENU'
                | translate: { name: displayTitle() }
        "
        [items]="menuActionItems"
        [tooltip]="'BUTTON.LABEL_BUTTON_OPEN_MENU' | translate"
    />
</div>
